import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class LaunchOperationUploadBankTransactions {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_id:string, max_date:string): Promise<any> {
    let args = { 
      bank_account_id: bank_account_id,
      max_date: max_date
    }    
    await this.dispatcher.dispatch('launch_operation.upload_bank_transactions', args);    
  }
}